import SafeApiKit from '@safe-global/api-kit'
import Safe from '@safe-global/protocol-kit'

import { SAFE_API_KEY } from 'constants/index'
import { provider as eip1193Provider } from 'libs/viem/config'

interface InitSafeClientsParams {
  safeAddress: `0x${string}`
  chainId: number
  signerAddress: `0x${string}`
}

export interface SafeClients {
  protocolKit: Safe
  apiKit: SafeApiKit
}

export const initSafeClients = async ({
  safeAddress,
  chainId,
  signerAddress,
}: InitSafeClientsParams): Promise<SafeClients> => {
  if (!SAFE_API_KEY) {
    throw new Error('Safe API key is missing. Set REACT_APP_SAFE_API_KEY in your env file.')
  }

  const protocolKit = await Safe.init({
    provider: eip1193Provider as any,
    signer: signerAddress,
    safeAddress,
  })

  const apiKit = new SafeApiKit({
    chainId: BigInt(chainId),
    apiKey: SAFE_API_KEY,
  })

  return { protocolKit, apiKit }
}
